export default __webpack_public_path__ + "static/media/aguasemgas.3ff02ca5.jpg";